export const defaultproducts = () => {
    return {
      products_kardex: []
    }
  }

export const defaultContacts = () => {
    return {
        data: [],
        total: 1
    }
}

export default {
  loading:{
    download_pdf:false,
    kardex:false
  },
  products: [],
  discountInconsistencies: [],
  types_validates: [
    {
      id:1,
      name:"Comprobantes descuadrados"
    },
    {
      id:2,
      name:"Documentos sin contabilizar"
    },
    {
      id:3,
      name:"Cuentas de total erradas"
    },
    {
      id:4,
      name:"Cuentas de Resultados"
    },
    {
      id:5,
      name:"Saldos de Cuentas"
    },
    {
      id:6,
      name:"Salto de Consecutivo"
    },
    {
      id:7,
      name:"Cuentas de Total Erradas"
    },
  ],

    branchOffices: [],
    branchoffice_warehouses: [],

    branchoffice_warehouses_entry: [],
    product:defaultproducts(),

    params: {
      type_validate:null,
      date_ini: '',
      date_end: ''
    },

    params_reconstructor: {
      date: null,
      product:null,
      document_product:null
  },

    paramsquery:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    paramsProducts:{
        validate_exhausted : false,
        paginate: false,
        product: '',
        branchoffice_warehouse_id: '',
        filter: '',
        page: 1,
        perPage: 15
    },
    document:'',
}



// WEBPACK FOOTER //
// ./src/modules/discount-inconsistencies/state.js